import { Component, OnInit, Input } from '@angular/core';
import { CatalogService } from '../catalog-api/catalog.service';
import { MetaData } from '../../catalogue/catalog-api/model/metadata';
import { DPAccount } from '../../portalv1/dp-account';
import { DatahealthService } from '../../catalogue/datahealth/datahealth.service';
import { Datahealth } from '../../catalogue/datahealth/datahealth';
import { DatahealthRequestObject } from '../../catalogue/datahealth/datahealthrequest';
import { DialogRef } from 'ngx-modialog';
import { Modal } from 'ngx-modialog/plugins/bootstrap';
import { ToasterService } from 'angular2-toaster/src/toaster.service';
import { QAService } from '../qa/qa.service';
import { BulkInfohashService } from '../../bulk-infohash/bulk-infohash.service';
import { GeneralConstants } from '../../shared/general.constants';
import { UserDetailsService } from '../../shared/user.details.service';
import { get } from 'lodash';
import {document} from 'ngx-bootstrap/utils/facade/browser';

@Component({
    selector: 'app-data-health',
    templateUrl: 'datahealth.component.html',
    styleUrls: ['datahealth.component.scss']
})
export class DataHealthComponent implements OnInit {

    @Input() selectedTitle: any;
    // used
    selectedParrotId: string;
    editMode = false;
    canEditMetadata = false;
    imdbChanged = [];
    selectedTitleName: string;
    selectedCatalogState: string;
    selectedContentType: string;
    // selectedTitle: MetaData;
    mappingReady = false;
    submitting = false;
    statusSubmitting = false;
    rawResults: any[];
    rawRequestResult = [];
    requestMappingCount = [];
    hasPendingMappings = false;
    sources = ['dailymotion', 'facebook', 'instagram_v2', 'gplus_v2', 'twitter', 'tvmaze', 'youtube', 'tumblr_v2', 'wikipedia', 'gtrends', 'bittorrent'];
    sportsSources = ['dailymotion', 'facebook', 'instagram_v2', 'gplus_v2', 'twitter', 'tvmaze', 'youtube', 'tumblr_v2', 'wikipedia', 'gtrends', 'semrush', 'bittorrent'];
    mapping_types = {
        'dailymotion': ['SEARCH_TERM'],
        'gplus_v2': ['SEARCH_TERM'],
        'facebook': ['ID'],
        'youtube': ['ID', 'VIDEO', 'PLAYLIST'],
        'instagram_v2': ['TAG', 'HANDLE'],
        'tumblr_v2': ['TAG', 'SEARCH_TERM'],
        'twitter': ['TAG', 'HANDLE', 'SEARCH_TERM'],
        'tvmaze': ['ID', 'SEARCH_TERM'],
        'gtrends': ['ID', 'SEARCH_TERM'],
        'wikipedia': ['LINK'],
        'semrush': ['DOMAIN', 'SUB_DOMAIN']
    };
    selectedSourceResult = [];
    selectedVideoSourceResult = [];
    selectedSearchTermResult = [];
    originalSearchTermResult = 0;
    updatedSearchTermResult = [];
    selectedRequestResult = [];
    reformedStatus: any[];
    selectedSource: string = 'dailymotion';
    selectedSourceIndex = 0;
    checkStatus = false;
    editMapping = false;
    createMapping = false;
    selectedMapping;
    mappingTypeOption = [];
    disabled = false;
    searchTitle = true;
    selectedState = 'pending';
    requestTitleList: any[];
    allLogs = false;
    allLogList = [];
    titleMappingRequestLoading = false;
    allLogMappingRequestLoading = false;
    CUDMappingRequestLoading = false;
    approvalMappingRequestLoading = false;
    bittorrentTotalCount = 0;
    bittorrentHumanVerfiedCount = 0;
    bittorrentSystemVerfiedCount = 0;
    bittorrentUnVerfiedCount = 0;

    // Youtube Search
    youtubeSearchQuery = '';
    loadingYoutubeSearch = false;
    youtubeSearchResults = [];
    ytSearchPageResponse;
    youtubeAdded = false;

    // dont know
    dialog: any;
    requestLoading = false;
    deleting = false;
    notificationTitle: any;
    notificationContent: any;
    notificationType: any;
    query = '';
    jsonstring: any;
    metadata: MetaData[];
    allTitles: MetaData[];
    filteredTitles: MetaData[];
    detailView = false;
    viewSearchResult = false;
    accounts: DPAccount[];
    selectedType = 1;
    mappingResult: Datahealth[];
    reformedResults: any[];
    statusReady = false;
    statusResult: Datahealth;
    resultReady = false;
    titleId: any;
    titlename: any;
    isViewAll = false;
    reqeusts: DatahealthRequestObject[];
    filteredRequests: DatahealthRequestObject[];
    mappingRequestLoading = false;
    isMappingApprover;
    presentInDailyInfohashCheck = undefined;
    dailyInfohashCheckLoading = false;
    loadMoreLoading = false;

    addMapping = false;
    validated = false;
    formSource = 'dailymotion';
    formMappingType = 'SEARCH_TERM';
    formMappingValue = '';
    formUpdatedMappingValue = '';
    checkedYoutubeAllTypes = false;
    viewRequestedMapping = false;
    section = 'tabView';
    currentInput;
    boundKeyListener: any;

    constructor(private toasterService: ToasterService,
        private catalogService: CatalogService,
        private datahealthService: DatahealthService,
        private bulkInfohashService: BulkInfohashService,
        public modal: Modal,
        private qaService: QAService,
        private userDetailsService: UserDetailsService
    ) { }

    clickCatalogFromRequest(id: string, name: string) {
        const title: MetaData = new MetaData();
        title.display_name = name;
        title.parrot_id = id;
        this.clickCatalog(title);
    }

    reset() {
        this.selectedRequestResult = [];
        this.selectedSourceResult = [];
        this.selectedSearchTermResult = [];
        this.originalSearchTermResult = 0;
        this.selectedSourceResult = [];
        this.allLogs = false;
        this.rawResults = [];
        this.rawRequestResult = [];
        this.createMapping = false;
        this.editMapping = false;
        this.checkStatus = false;
        this.statusSubmitting = false;
        this.submitting = true;
        this.mappingReady = false;
        this.reformedStatus = undefined;
        this.allLogList = [];
        this.bittorrentTotalCount = 0;
        this.bittorrentHumanVerfiedCount = 0;
        this.bittorrentSystemVerfiedCount = 0;
        this.bittorrentUnVerfiedCount = 0;
    }

    clickCatalog(title: any) {
        this.reset();
        this.selectedTitle = title;
        this.selectedParrotId = title.parrot_id;
        this.selectedTitleName = title.title;
        this.selectedCatalogState = title.catalog_state;
        this.query = title.display_name;
        this.selectedContentType = title.content_type;

        // const contentType = this.selectedContentType === 'sports' ? 'show' : this.selectedContentType;
        const contentType = this.selectedContentType;

        this.datahealthService
            .getMapping(title.parrot_id, false, contentType)
            .then(res => {
                this.processMappingResult(res);
                this.getMappingRequestTitlesNId();
            })
            .catch(error => {
                this.errorHandler(error);
            });
    }
    checkHealth() {
        this.reformedStatus = undefined;
        this.checkStatus = true;
        this.statusSubmitting = true;
        this.datahealthService
            .getMapping(this.selectedParrotId, true, null)
            .then(res => {
                this.processStatusResult(res);
            })
            .catch(error => {
                this.errorHandler(error);
            });
    }
    async processMappingResult(input: any) {
        this.currentInput = input;
        const mapping = input.mapping;
        const youtube = mapping.youtube || [];
        const dailymotion = mapping.dailymotion || [];
        const facebook = mapping.facebook || [];
        const instagram_v2 = mapping.instagram_v2 || [];
        const gplus_v2 = mapping.gplus_v2 || [];
        const tumblr_v2 = mapping.tumblr_v2 || [];
        const wikipedia = (mapping.wikipedia || []).length > 1000 ? (mapping.wikipedia || []).slice(0, 10) : (mapping.wikipedia || []);
        const tvmaze = mapping.tvmaze || [];
        const twitter = mapping.twitter || [];
        const gtrends = mapping.gtrends || [];
        const semrush = mapping.semrush || [];

        const bittorrent = this.catalogService.getBittorentDate(
            this.selectedParrotId,
        ).then((res) => {
            const results = res.title_stats.map(item => this.infohashStatsItem(item));
            this.bittorrentTotalCount = results[0].total_torrents;
            this.bittorrentHumanVerfiedCount = results[0].human_verified;
            this.bittorrentSystemVerfiedCount = results[0].system_verified;
        }).catch((err) => {
            console.error('Failed to get bittorent count results in the catalog API' + err.toString());
        });

        // const bittorrent = mapping.bittorrent ?
        //     mapping.bittorrent.map((bittorrentItem) => {
        //         bittorrentItem.date_discovered = (new Date(bittorrentItem.date_discovered)).toLocaleDateString('ja');
        //         bittorrentItem.latest_date = (new Date(bittorrentItem.latest_date)).toLocaleDateString('ja');
        //
        //
        //
        //         return bittorrentItem;
        //     })
        //     : [];

        if (this.selectedContentType === 'sports') {
            this.rawResults = [dailymotion, facebook, instagram_v2, gplus_v2, twitter, tvmaze, youtube, tumblr_v2, wikipedia, gtrends, semrush, bittorrent];
        } else {
            this.rawResults = [dailymotion, facebook, instagram_v2, gplus_v2, twitter, tvmaze, youtube, tumblr_v2, wikipedia, gtrends, bittorrent];
        }

        this.clickSource(this.selectedSourceIndex);
    }

    infohashStatsItem(item) {
        // // console.log(item);
        return {
            system_verified: item.system_verified ? item.system_verified : 'N/A',
            total_torrents: item.total_torrents ? item.total_torrents : 'N/A',
            human_verified: item.human_verified ? item.human_verified : 'N/A'
        };
    }

    processStatusResult(input) {
        const status = input.status;
        this.reformedStatus = [status.dailymotion, status.facebook, status.instagram_v2, status.gplus_v2, status.twitter,
        status.tvmaze, status.youtube, status.tumblr_v2, status.wikipedia, 2, status.bittorrent];

        this.statusSubmitting = false;

    }

    deleteMapping(mapping: any) {
        mapping.requestUser = this.userDetailsService.getCachedUserName();
        mapping.content_type = this.selectedContentType;

        if (this.selectedSource === 'bittorrent') {
            // Change the mapping object so we can send it through to the endpoint.
            mapping = {
                title_id: mapping.title_id,
                title: mapping.title,
                mapping_type: mapping.mapping_type,
                mapping_value: mapping.mapping_value,
                state: mapping.state,
                requestUser: mapping.requestUser,
                content_type: mapping.content_type
            };
        }
        // // console.log(this.selectedContentType);

        this.datahealthService.deleteMapping(this.selectedSource, mapping, this.selectedContentType)
            .then(res => {
                this.clickCatalog(this.selectedTitle);
                this.getMappingRequestTitles();
            })
            .catch(error => {
                this.errorHandler(error);
            });
    }
    getSourceMappingCount(i: number, source: string): string {
        if (source === 'bittorrent') {
            return `${this.bittorrentTotalCount}`;
        }
        if (source === 'youtube') {
            return `${this.getYoutubeIDPlaylists(this.rawResults[i]).length}/${this.rawResults[i].length}`;
        } else {
            return `${this.rawResults[i].length}`;
        }
    }

    changeYoutubeAllTypes(checkedYoutubeAllTypes: boolean) {
        this.checkedYoutubeAllTypes = checkedYoutubeAllTypes;
        this.clickSource(this.selectedSourceIndex);
    }

    getYoutubeIDPlaylists(sourceResult): any[] {
        let ytHasNoChannel;
        if (this.selectedContentType === 'movie') {
             ytHasNoChannel = sourceResult.filter(item => {
                return item.mapping_type === 'SEARCH_TERM' && item.mapping_value === 'NO_CHANNEL';
            }).length > 1;
        } else {
            ytHasNoChannel = sourceResult.filter(item => {
                return item.mapping_value === 'NO_CHANNEL';
            }).length > 0;
        }
        let finalResult;
        if (ytHasNoChannel) {
            finalResult = sourceResult.filter(item => item.mapping_value !== 'NO_CHANNEL');
        } else {
            finalResult = sourceResult.filter(item => ['ID', 'PLAYLIST', 'SEARCH_TERM'].indexOf(item.mapping_type) !== -1);
            finalResult = finalResult.filter(item => !(item.mapping_type === 'SEARCH_TERM' && item.mapping_value === 'NO_CHANNEL'));
        }
        return finalResult;
    }

    getYoutubeIDPlaylistsAll(sourceResult): any[] {
        // console.log(sourceResult);
        let ytHasNoChannel;
        if (this.selectedContentType === 'movie') {
            ytHasNoChannel = sourceResult.filter(item => {
                return item.mapping_type === 'SEARCH_TERM' && item.mapping_value === 'NO_CHANNEL';
            }).length > 1;
        } else {
            ytHasNoChannel = sourceResult.filter(item => {
                return item.mapping_value === 'NO_CHANNEL';
            }).length > 0;
        }
        let finalResult;
        if (ytHasNoChannel) {
            finalResult = sourceResult.filter(item => item.mapping_value !== 'NO_CHANNEL');
        } else {
            finalResult = sourceResult.filter(item => ['VIDEO', 'ID', 'PLAYLIST', 'SEARCH_TERM'].indexOf(item.mapping_type) !== -1);
            finalResult = finalResult.filter(item => !(item.mapping_type === 'SEARCH_TERM' && item.mapping_value === 'NO_CHANNEL'));
        }
        return finalResult;
    }

    clickSource(index: any) {
        this.selectedSourceResult = this.rawResults[index];
        this.selectedSourceIndex = index;
        if (this.selectedContentType === 'sports') {
            this.selectedSource = this.sportsSources[index];
        } else {
            this.selectedSource = this.sources[index];
        }
        this.editMapping = false;
        this.createMapping = false;
        this.selectedRequestResult = this.rawRequestResult[index];

        // Set the pending flag to the source mappings
        this.selectedSourceResult = this.selectedSourceResult.map((item) => {
            if (this.selectedRequestResult &&
                this.selectedRequestResult.find((findItem) => findItem.mapping_value === item.mapping_value)) {
                item.pending = true;
            }
            return item;
        });


        if (this.selectedSource === 'youtube') {
            this.selectedVideoSourceResult = this.getYoutubeIDPlaylistsAll(this.selectedSourceResult);
            if (!this.checkedYoutubeAllTypes) {
                this.selectedSourceResult = this.getYoutubeIDPlaylists(this.selectedSourceResult);
                this.selectedSearchTermResult = this.getSearchtermListYoutube(this.selectedSourceResult);
            }
        } else if (this.selectedSource === 'bittorrent') {
            if (this.selectedRequestResult && this.selectedSourceResult) {
                const infohashArray = this.selectedRequestResult.map((item => item.mapping_value));
                const parrotIds = this.selectedRequestResult.map((item) => item.new_mapping);
                if (infohashArray.length > 0 && parrotIds.length > 0) {
                    // For bittorrent pending mappings, grab their torrent name and display name
                    Promise.all([
                        this.bulkInfohashService.getPendingCumulativeTorrents(infohashArray),
                        this.catalogService.callEsProxyForParrotIds(parrotIds, ['parrot_id', 'display_name', 'data.original_country', 'data.release_year'])
                    ])
                        .then((res) => {
                            // Set torrent name using the pending cumulative torrents response
                            this.selectedRequestResult = this.selectedRequestResult.map((item) => {
                                const pendingCumulativeTorrentItem = res[0]['results'].find((resultsItem) => item.mapping_value === resultsItem.infohash);
                                if (pendingCumulativeTorrentItem) {
                                    return {
                                        ...item,
                                        torrent_name: pendingCumulativeTorrentItem.torrentName
                                    };
                                } else {
                                    return item;
                                }
                            });

                            // Set display name using the call es proxy for parrot ids response
                            this.selectedRequestResult = this.selectedRequestResult.map((item) => {
                                const esItem = res[1]['hits']['hits'].find((esHitItem) => item.new_mapping === esHitItem._source.parrot_id);
                                if (esItem) {
                                    return {
                                        ...item,
                                        display_name: [
                                            esItem._source.display_name,
                                            esItem._source.data.original_country['0'],
                                            esItem._source.data.release_year
                                            // tslint:disable-next-line:no-shadowed-variable
                                        ].filter(item => item).join(' - ')
                                    };
                                } else {
                                    return {
                                        ...item,
                                        display_name: 'Map to null'
                                    };
                                }
                            });

                            // Sort the current mappings by latest date.
                            this.selectedSourceResult = this.selectedSourceResult.sort((a, b) => {
                                return (new Date(b.latest_date)).getTime() - (new Date(a.latest_date)).getTime();
                            });
                        })
                        .catch((err) => {
                            console.error('Failed to obtain additional information for mapping requests: ', err.toString());
                            this.toasterService.pop('error', 'Failed to obtain additional information for mapping requests');
                        });
                }
            }
        }
    }

    getAllCatalogues() {
        this.catalogService.getAllCatalogue()
            .then(res => {
                this.allTitles = res.metadata;
            })
            .catch(error => {
                this.errorHandler(error);
            });
    }

    getMappingRequestTitles() {
        // // console.log(this.selectedContentType);

        this.goBack();
        this.titleMappingRequestLoading = true;
        this.requestTitleList = [];
        this.datahealthService
            .getMappingRequestTitleByState(this.selectedState, this.selectedContentType)
            .then(res => {
                // tslint:disable-next-line:forin
                for (const k in res) {
                    const title: any = new Object();
                    title.title_id = k;
                    const list = res[k].sort((a, b) => new Date(b.createdOn).getTime() - new Date(a.createdOn).getTime());
                    title.requests = list;
                    title.latest_date = list[0].createdOn;
                    this.requestTitleList.push(title);
                    this.requestTitleList.sort((a, b) => new Date(b.latest_date).getTime() - new Date(a.latest_date).getTime());
                }
                this.titleMappingRequestLoading = false;
            })
            .catch(error => {
                this.errorHandler(error);
            });
    }

    getMappingRequestTitlesNId() {
        this.datahealthService
            .getMappingRequestTitleByStateNId('pending', this.selectedParrotId, this.selectedContentType)
            .then(res => {
                this.hasPendingMappings = res.length > 0;
                this.processRawMappingRequest(res);
            })
            .catch(error => {
                this.errorHandler(error);
            });
    }

    processRawMappingRequest(result: any[]) {
        result.sort((a, b) => new Date(b.createdOn).getTime() - new Date(a.createdOn).getTime());
        if (this.selectedContentType !== 'sports') {
            this.sources.forEach(x => {
                const sourcelist = result.filter(y => y.source === x);
                this.rawRequestResult.push(sourcelist);
            });
        } else {
            this.sportsSources.forEach(x => {
                const sourcelist = result.filter(y => y.source === x);
                this.rawRequestResult.push(sourcelist);
            });
        }

        this.clickSource(this.selectedSourceIndex);

        this.mappingReady = true;
        this.submitting = false;
    }

    ngOnInit() {
        this.isMappingApprover = this.userDetailsService.isMappingApprover();
        this.clickCatalog(this.selectedTitle);
    }

    filter(term: string) {
        this.selectedParrotId = undefined;
        this.query = term;
        if (term !== '') {
            this.filteredTitles = this.allTitles.filter(u => {
                if (u.title.toLowerCase().includes(term.toLowerCase())) {
                    return u;
                } else if (u.parrot_id.toLowerCase().includes(term.toLowerCase())) {
                    return u;
                } else if (u.display_name.toLowerCase().includes(term.toLowerCase())) {
                    return u;
                }
            });
        } else {
            this.filteredTitles = [];
        }
    }


    checkAllLogs() {
        this.allLogMappingRequestLoading = true;

        this.datahealthService.getMappingRequestTitleByStateNId('all', this.selectedParrotId , this.selectedContentType)
            .then(res => {
                this.allLogList = res.sort((a, b) => new Date(b.createdOn).getTime() - new Date(a.createdOn).getTime());
                this.allLogMappingRequestLoading = false;

            })
            .catch(error => {
                this.errorHandler(error);
            });
        this.allLogs = true;

    }

    goBack() {
        this.editMapping = false;
        this.createMapping = false;
        this.selectedMapping = undefined;
        this.allLogs = false;
        this.youtubeSearchQuery = '';
        this.youtubeSearchResults = [];
    }

    filteredSources() {
        if (this.selectedContentType === 'sports') {
            return this.sportsSources;
        } else {
            return this.sources;
        }
    }

    clickEditMapping(mapping: any, contentType) {
        this.editMapping = true;
        this.selectedMapping = mapping;
        this.selectedMapping.title_id = this.selectedSource !== 'bittorrent' ?
            this.selectedParrotId : this.selectedMapping.title_id;
        this.selectedContentType =  contentType;
        this.selectedMapping.title = this.selectedTitle.title;
        this.selectedMapping.new_mapping_value = '';
        this.selectedMapping.source = this.selectedSource;
        this.selectedMapping.requestUser = this.userDetailsService.getCachedUserName();
    }

    clickCreateMapping() {
        this.createMapping = true;
        this.selectedMapping = new Object();
        this.selectedMapping.title_id = this.selectedParrotId;
        this.selectedMapping.title = (this.selectedTitle.title).replace(/[^a-zA-Z0-9 ]/g, '').trim();
        this.selectedMapping.content_type = this.selectedTitle.content_type;
        this.selectedMapping.mapping_type = '';
        this.selectedMapping.mapping_value = '';
        this.selectedMapping.source = this.selectedSource;
        this.selectedMapping.requestUser = this.userDetailsService.getCachedUserName();

        this.handleMappingType();
    }

    handleMappingType() {
        if (this.selectedSource === 'youtube' && this.selectedContentType === 'movie' ) {
            this.mappingTypeOption = ['ID', 'VIDEO', 'PLAYLIST', 'SEARCH_TERM'];
        } else {
            this.mappingTypeOption = this.mapping_types[this.selectedSource];
        }
        this.initializeFirstMappingType();
    }

    initializeFirstMappingType() {
        if (this.selectedMapping && this.mappingTypeOption.length > 0) {
            this.selectedMapping.mapping_type = this.mappingTypeOption[0];
        }
    }

    clickUpdate() {
        this.selectedMapping.requestUser = this.userDetailsService.getCachedUserName();

        let mapping;

        this.selectedMapping.content_type = this.selectedContentType;

        if (this.selectedSource === 'bittorrent') {
            // Change the mapping object so we can send it through to the endpoint.
            mapping = {
                title_id: this.selectedMapping.title_id,
                title: this.selectedMapping.title,
                mapping_type: this.selectedMapping.mapping_type,
                mapping_value: this.selectedMapping.mapping_value,
                human_verified: this.selectedMapping.human_verified,
                state: this.selectedMapping.state,
                requestUser: this.selectedMapping.requestUser,
                new_mapping_value: this.selectedMapping.new_mapping_value,
                content_type: this.selectedContentType
            };
        } else if (this.selectedSource === 'youtube') {
            mapping = {
                ...this.selectedMapping
                // TODO: add published at time
            };
        } else {
            mapping = this.selectedMapping;
        }
        // // console.log(this.selectedContentType);

        this.datahealthService.updateMapping(this.selectedSource, mapping, this.selectedContentType)
            .then(res => {
                this.clickCatalog(this.selectedTitle);
                this.getMappingRequestTitles();
            })
            .catch(error => {
                this.errorHandler(error);
            });
    }

    clickCreate() {
        // // console.log(this.selectedContentType);

        this.selectedMapping.requestUser = this.userDetailsService.getCachedUserName();
        this.selectedMapping.content_type = this.selectedContentType;

        const shouldCreatePlaylist = this.selectedSource === 'youtube' && this.selectedContentType === 'sports' &&
                                     this.selectedMapping.mapping_type === 'ID' && this.selectedMapping.include_default_playlist;

        const channelId = this.selectedMapping.mapping_value;
        const mappingData = {
            title_id: this.selectedMapping.title_id,
            title: this.selectedMapping.title,
            content_type: this.selectedMapping.content_type,
            requestUser: this.selectedMapping.requestUser
        };

        delete this.selectedMapping.include_default_playlist;

        this.datahealthService.createMapping(this.selectedSource, this.selectedMapping, this.selectedContentType)
            .then(res => {
                if (this.selectedSource === 'youtube' && this.selectedMapping.mapping_type === 'VIDEO') {
                    // Do not refresh page, set the video to completed
                    this.youtubeAdded = true;
                    const updatedVideo = this.youtubeSearchResults.find(item => item.id === this.selectedMapping.mapping_value);
                    if (updatedVideo) {
                        updatedVideo.exists = true;
                        updatedVideo.loading = false;
                    } else {
                        this.toasterService.pop('error', 'Updated video not found in video results');
                        console.error(`Updated video ${this.selectedMapping.mapping_value} not found in video results: ` + this.youtubeSearchResults);
                    }
                } else {
                    if (shouldCreatePlaylist) {
                        return this.createPlaylistMapping(channelId, mappingData);
                    }
                }
            })
            .then(() => {
                if (!(this.selectedSource === 'youtube' && this.selectedMapping.mapping_type === 'VIDEO')) {
                    this.clickCatalog(this.selectedTitle);
                    this.getMappingRequestTitles();
                }
            })
            .catch(error => {
                this.errorHandler(error);
            });
    }
    handleBlur() {
        setTimeout(() => {
            this.filteredTitles = [];
        }, 200);
    }



    refineState(state: any) {
        if (state === 1) {
            return 'In System';
        } else if (state === 2) {
            return 'Not in System';
        } else {
            return 'N/A';
        }
    }
    createNotification() {
        switch (this.notificationType) {
            case 'success':
                // this._service.success(this.notificationTitle, this.notificationContent);
                this.toasterService.pop('success', this.notificationTitle, this.notificationContent);
                break;
            case 'error':
                this.toasterService.pop('error', this.notificationTitle, this.notificationContent);
                // this._service.error(this.notificationTitle, this.notificationContent);
                break;
            case 'info':
                this.toasterService.pop('info', this.notificationTitle, this.notificationContent);
                // this._service.info(this.notificationTitle, this.notificationContent);
                break;
        }
    }

    errorHandler(error: any) {
        this.submitting = false;
        this.titleMappingRequestLoading = false;
        this.allLogMappingRequestLoading = false;
        this.CUDMappingRequestLoading = false;
        this.approvalMappingRequestLoading = false;
        this.statusSubmitting = false;

        this.notificationType = 'error';
        this.notificationTitle = 'Error';
        if (error._body !== undefined) {
            const jsonErrorBody = JSON.parse(error._body);
            this.notificationContent = jsonErrorBody.error.message;
        } else {
            this.notificationContent = error;
        }
        this.createNotification();
    }


    handleDate(date: string) {
        if (date !== undefined) {
            return new Date(date).toLocaleDateString() + ' ' + new Date(date).toLocaleTimeString();
        } else {
            return undefined;
        }

    }

    handleTitle(titleId: string) {
        if (titleId !== undefined) {
            const title = this.allTitles.find(u => u.parrot_id === titleId).display_name;
            if (title) {
                return title;

            } else {
                return titleId;
            }
        } else {
            return undefined;
        }
    }

    viewInfo(source: string, mapping_type: string, mapping_value: string) {
        if (source === 'dailymotion') {
            const newWindow = window.open('http://www.dailymotion.com/search/' + mapping_value);
        } else if (source === 'facebook') {
            const newWindow = window.open('https://www.facebook.com/' + mapping_value);
        } else if (source === 'instagram_v2') {
            if (mapping_type === 'TAG') {
                const newWindow = window.open('https://www.instagram.com/explore/tags/' + mapping_value);
            } else {
                const newWindow = window.open('https://www.instagram.com/' + mapping_value);
            }
        } else if (source === 'gplus_v2') {
            const newWindow = window.open('https://plus.google.com/s/' + mapping_value);
        } else if (source === 'twitter') {
            if (mapping_type === 'HANDLE') {
                const newWindow = window.open('https://twitter.com/' + mapping_value);
            } else if (mapping_type === 'TAG') {
                const newWindow = window.open('https://twitter.com/search?q=%23' + mapping_value + '&src=typed_query');
            } else if (mapping_type === 'SEARCH_TERM') {
                const newWindow = window.open('https://twitter.com/search?q=' + mapping_value + '&src=typed_query');
            }
        } else if (source === 'tvmaze') {
            if (mapping_type === 'SEARCH_TERM') {
                const newWindow = window.open('https://www.tvmaze.com/search?q=' + mapping_value);
            } else if (mapping_type === 'ID') {
                if ( this.selectedContentType === 'talent' ) {
                    const newWindow = window.open('https://www.tvmaze.com/people/' + mapping_value + '/' + (this.selectedTitleName).replace(/ /g, '-') );

                }  else {
                    const newWindow = window.open('https://www.tvmaze.com/shows/' + mapping_value);
                }
            }
        } else if (source === 'youtube') {
            if (mapping_type === 'ID') {
                const newWindow = window.open('https://www.youtube.com/channel/' + mapping_value);
            } else if (mapping_type === 'PLAYLIST') {
                const newWindow = window.open('https://www.youtube.com/watch?v=-&list=' + mapping_value);
            } else if (mapping_type === 'VIDEO') {
                const newWindow = window.open('https://www.youtube.com/watch?v=' + mapping_value);
            } else if (mapping_type === 'SEARCH_TERM') {
                const newWindow = window.open('https://www.youtube.com/results?search_query=' + mapping_value);
            }
        } else if (source === 'gtrends') {
            const newWindow = window.open('https://trends.google.com/trends/explore?q=' + mapping_value);
        } else if (source === 'tumblr_v2') {
            if ( mapping_value.includes('#') ) {
                mapping_value = mapping_value.replace('#', '%23');
            }
            const newWindow = window.open('https://www.tumblr.com/search/' + mapping_value);
        }
        // tslint:disable-next-line:one-line
        else if (source === 'wikipedia') {
            const newWindow = window.open(mapping_value);
        }
    }

    onClickIsApproval(mappingRequest, state, event: any) {
        event.stopPropagation();
        this.approvalMappingRequestLoading = true;

        const dialogMessage = 'You really want to ' + state + ' this mapping?';
        this.dialog = this.modal.confirm()
            .size('sm')
            .isBlocking(false)
            .showClose(false)
            .keyboard(27)
            .body(dialogMessage)
            .okBtn('Yes')
            .cancelBtn('No')
            .open();
        this.processDialogActivationApproval(mappingRequest.idMappingRequest, state, this.dialog);
    }

    private processDialogActivationApproval(idMapping: any, state: string, dialog: Promise<DialogRef<any>>) {
        // // console.log(this.selectedContentType);
        this.boundKeyListener = (event) => this.enterKeyListener(event);
        document.addEventListener('keyup', this.boundKeyListener);
        dialog.then((resultPromise) => {
            return resultPromise.result.then((result) => {
                    this.performMappingApprovalAction(idMapping, state);
                    document.removeEventListener('keyup', this.boundKeyListener);
                }
                , () => {
                    this.approvalMappingRequestLoading = false;
                    document.removeEventListener('keyup', this.boundKeyListener);
                });
        });
    }


    private performMappingApprovalAction(idMapping: any, state: string) {
        this.datahealthService
            .handleMappingRequest(idMapping, state, this.selectedContentType)
            .then(res => {
                this.clickCatalog(this.selectedTitle);
                this.getMappingRequestTitles();
                this.approvalMappingRequestLoading = false;
            })
            .catch(error => {
                this.errorHandler(error);
                this.approvalMappingRequestLoading = false;
            });
    }

    onClickDelete(mapping: any, event: any) {
        event.stopPropagation();
        if (mapping === 'wikipedia') {
            mapping = this.selectedSourceResult[0];
            mapping.language = undefined;
        }

        const dialogMessage = 'You really want to delete this mapping?';
        this.dialog = this.modal.confirm()
            .size('sm')
            .isBlocking(false)
            .showClose(false)
            .keyboard(27)
            .body(dialogMessage)
            .okBtn('Yes')
            .cancelBtn('No')
            .open();
        this.processDialogActivationDelete(mapping, event, this.dialog);
    }
    private processDialogActivationDelete(mapping: any, event: any, dialog: Promise<DialogRef<any>>) {
        this.boundKeyListener = (event) => this.enterKeyListener(event);
        document.addEventListener('keyup', this.boundKeyListener);
        dialog.then((resultPromise) => {
            return resultPromise.result.then((result) => {
                this.deleteMapping(mapping);
                document.removeEventListener('keyup', this.boundKeyListener);
            }, () => {
                document.removeEventListener('keyup', this.boundKeyListener);
            });
        });
    }
    onClickUpdate(event: any) {

        if (this.selectedMapping.mapping_type === 'SEARCH_TERM' && this.selectedMapping.source === 'youtube') {
            const mappingValue = this.selectedSearchTermResult.map(x => x).join('|');
            this.selectedMapping.new_mapping_value = mappingValue;
        }

        if (this.selectedSource !== 'bittorrent'
            && (this.selectedMapping.new_mapping_value === ''
                || this.selectedMapping.new_mapping_value === undefined)) {
            this.errorHandler('wrong input please check again');
        } else if (this.selectedSource === 'bittorrent' && !this.selectedMapping.new_mapping_value) {
            this.errorHandler('Title to redirect to was not selected');
        } else {
            event.stopPropagation();
            const dialogMessage = 'You really want to update this mapping?';
            // this.viewInfo(this.selectedMapping.source, this.selectedMapping.mapping_type, this.selectedMapping.mapping_value)
            this.dialog = this.modal.confirm()
                .size('sm')
                .isBlocking(false)
                .showClose(false)
                .keyboard(27)
                .body(dialogMessage)
                .okBtn('Yes')
                .cancelBtn('No')
                .open();
            this.processDialogActivationUpdate(event, this.dialog);
        }
    }
    private processDialogActivationUpdate(event: any, dialog: Promise<DialogRef<any>>) {

        this.boundKeyListener = (event) => this.enterKeyListener(event);
        document.addEventListener('keyup', this.boundKeyListener);

        dialog.then((resultPromise) => {
            return resultPromise.result.then((result) => {
                this.clickUpdate();
                document.removeEventListener('keyup', this.boundKeyListener);
            }, () => {
                document.removeEventListener('keyup', this.boundKeyListener);
            });
        });
    }

    onClickCreate(event: any) {

        if (this.selectedMapping.mapping_type === 'SEARCH_TERM' && this.selectedMapping.source === 'youtube') {
            const mappingValue = this.selectedSearchTermResult.map(x => x).join('|');
            this.selectedMapping.mapping_value = mappingValue;
        }

        if (this.selectedMapping.mapping_type === 'Please select mapping type!' || this.selectedMapping.mapping_value === '' || this.selectedMapping.mapping_value === undefined) {
            this.errorHandler('wrong input please check again');
        } else {
            event.stopPropagation();
            const dialogMessage = 'You really want to create this mapping?';
            // this.viewInfo(this.selectedMapping.source, this.selectedMapping.mapping_type, this.selectedMapping.mapping_value)
            this.dialog = this.modal.confirm()
                .size('sm')
                .isBlocking(false)
                .showClose(false)
                .keyboard(27)
                .body(dialogMessage)
                .okBtn('Yes')
                .cancelBtn('No')
                .open();

            this.processDialogActivationCreate(event, this.dialog);
        }
    }

    createPlaylistMapping(channelId: string, mappingData: any) {
        // console.log('Creating playlist mapping for channel ID:', channelId);
        return this.datahealthService.getYoutubeChannel(channelId)
            .then(res => {
                // console.log('Channel response received:', res);
                const uploadsPlaylistId = res.items[0].contentDetails.relatedPlaylists.uploads;
                // console.log('Uploads playlist ID:', uploadsPlaylistId);
                const playlistMapping = {
                    title_id: mappingData.title_id,
                    title: mappingData.title,
                    content_type: mappingData.content_type,
                    mapping_type: 'PLAYLIST',
                    mapping_value: uploadsPlaylistId,
                    source: 'youtube',
                    requestUser: mappingData.requestUser
                };
                // console.log('Creating playlist mapping:', playlistMapping);
                return this.datahealthService.createMapping('youtube', playlistMapping, this.selectedContentType);
            })
            .then(() => {
                // console.log('Playlist mapping created successfully');
            })
            .catch(error => {
                console.error('Error creating playlist mapping:', error);
                this.errorHandler(error);
            });
    }

    enterKeyListener(event: KeyboardEvent) {
        if (event.key === 'Enter') {
            document.removeEventListener('keyup', this.boundKeyListener);
            this.dialog.then(window => window.close());
        }
    }
    private processDialogActivationCreate(event: any, dialog: Promise<DialogRef<any>>) {
        // Bind the Enter key listener to the dialog's OK action
        this.boundKeyListener = (event) => this.enterKeyListener(event);
        document.addEventListener('keyup', this.boundKeyListener);

        dialog.then((resultPromise) => {
            return resultPromise.result.then((result) => {
                this.clickCreate();
                document.removeEventListener('keyup', this.boundKeyListener);
            }, () => {
                document.removeEventListener('keyup', this.boundKeyListener);
            });
        });
    }

    private processDialogActivationSearchTerm(event: any, dialog: Promise<DialogRef<any>>) {
        dialog.then((resultPromise) => {
            return resultPromise.result.then((result) => {
                this.clickCreate();
            }, () => {
            });
        });
    }

    onClickApproveAll(event: any) {
        event.stopPropagation();
        const dialogMessage = 'Do you really want to approve all pending mappings?';
        this.dialog = this.modal.confirm()
            .size('sm')
            .isBlocking(false)
            .showClose(false)
            .keyboard(27)
            .body(dialogMessage)
            .okBtn('Yes')
            .cancelBtn('No')
            .open();
        this.processDialogActivationApproveAll(event, this.dialog);
    }

    async onClickApproveAllBySource(source: string, state: string, event: any) {
        // // console.log(this.selectedContentType);
        event.stopPropagation();
        this.approvalMappingRequestLoading = true;
        const dialogMessage = `You really want to ${state} all ${source} pending mappings?`;
        this.dialog = this.modal.confirm()
            .size('sm')
            .isBlocking(false)
            .showClose(false)
            .keyboard(27)
            .body(dialogMessage)
            .okBtn('Yes')
            .cancelBtn('No')
            .open();
        const resultPromise = await this.dialog;
        try {
            const result = await resultPromise.result;
            // console.log(this.selectedContentType);
            if (result) {
                const requestIds: any = this.selectedRequestResult.map(request => request.idMappingRequest);
                Promise.all(requestIds.map(
                    id => this.datahealthService.handleMappingRequest(id, state, this.selectedContentType))
                ).then(resArray => {
                    this.toasterService.pop('success', 'Successfully approved all pending requests');
                    this.clickCatalog(this.selectedTitle);
                    this.approvalMappingRequestLoading = false;
                    this.getMappingRequestTitles();
                }).catch(err => {
                    this.toasterService.pop('error', 'At least one of the approvals returned an error');
                    this.approvalMappingRequestLoading = false;
                    console.error(err);
                });
            } else {
                this.approvalMappingRequestLoading = false;
            }
        } catch (ex) {
            this.approvalMappingRequestLoading = false;
        }
    }
    viewInfoAllBySource(source: string, event: any) {
        for (const request of this.selectedRequestResult) {
            this.viewInfo(source, request.mapping_type, request.mapping_value);
        }
    }


    processDialogActivationApproveAll(event: any, dialog: Promise<DialogRef<any>>) {
        dialog.then((resultPromise) => {
            return resultPromise.result.then((result) => {
                // Get all pending mappings and send them all to approval with promise all
                const requestIds: any = this.rawRequestResult.map(source => {
                    return source.map(request => request.idMappingRequest);
                });
                const requestIdsFlattened = requestIds.flat();
                // console.log(this.selectedContentType);

                Promise.all(requestIdsFlattened.map(
                    id => this.datahealthService.handleMappingRequest(id, 'approve', this.selectedContentType))
                )
                    .then(resArray => {
                        this.toasterService.pop('success', 'Successfully approved all pending requests');
                        this.clickCatalog(this.selectedTitle);
                        this.getMappingRequestTitles();
                    })
                    .catch(err => {
                        this.toasterService.pop('error', 'At least one of the approvals returned an error');
                        this.approvalMappingRequestLoading = false;
                        console.error(err);
                    });
            }, () => { });
        });
    }

    onTitleSearchBoxEvent(eventArray) {
        this.selectedMapping.new_mapping_value = eventArray[0];
        this.selectedMapping.display_name = eventArray[1];
    }

    handleCheckDailyInfohash() {
        this.dailyInfohashCheckLoading = true;
        this.catalogService.checkIfPresentInDailyInfohashes(this.selectedParrotId)
            .then((res) => {
                this.dailyInfohashCheckLoading = false;
                // console.log({ res, resExists: res.exists });
                if (res.exists) {
                    this.presentInDailyInfohashCheck = 'present';
                } else {
                    this.presentInDailyInfohashCheck = 'not present';
                }
            })
            .catch((err) => {
                this.dailyInfohashCheckLoading = false;
                console.error('Failed to check if the title is in the daily infohash check table: ', err.toString());
                this.toasterService.pop('error', 'Failed to check if the title is in the daily infohash check table');
            });
    }

    handleAddToDailyInfohash() {
        this.dailyInfohashCheckLoading = true;
        this.catalogService.addToDailyInfohashes(this.selectedParrotId)
            .then((res) => {
                this.dailyInfohashCheckLoading = false;
                this.presentInDailyInfohashCheck = 'present';
            })
            .catch((err) => {
                this.dailyInfohashCheckLoading = false;
                console.error('Failed to add title to the daily infohash check table: ', err.toString());
                this.toasterService.pop('error', 'Failed to add title to the daily infohash check table');
            });
    }

    handleRemoveFromDailyInfohash() {
        this.dailyInfohashCheckLoading = true;
        this.catalogService.removeFromDailyInfohashes(this.selectedParrotId)
            .then((res) => {
                this.dailyInfohashCheckLoading = false;
                this.presentInDailyInfohashCheck = 'not present';
            })
            .catch((err) => {
                this.dailyInfohashCheckLoading = false;
                console.error('Failed to remove title from the daily infohash check table: ', err.toString());
                this.toasterService.pop('error', 'Failed to remove title from the daily infohash check table');
            });
    }

    handleLoadMore() {
        this.loadMoreLoading = true;
        const titleId = this.selectedParrotId;
        const source = this.selectedSource;
        // Shouldn't need to use floor as it should have no decimal component.
        // However, just to be safe we will.
        const page = Math.floor(this.selectedSourceResult.length / 100);
        this.catalogService.getMappings(titleId, source, page)
            .then((res) => {
                if (source === 'bittorrent') {
                    const additionalMappings = res.mapping.bittorrent.map((item) => {
                        item.date_discovered = (new Date(item.date_discovered)).toLocaleDateString('ja');
                        item.latest_date = (new Date(item.latest_date)).toLocaleDateString('ja');
                        return item;
                    });
                    this.rawResults[this.selectedSourceIndex] = this.rawResults[this.selectedSourceIndex]
                        .concat(additionalMappings);
                } else {
                    this.toasterService.pop('error', 'Loading more items for this source is not supported!');
                    console.error('Loading more items for this source is not supported!');
                }

                this.loadMoreLoading = false;
                this.clickSource(this.selectedSourceIndex);
            });
    }

    hasNextVideoSearchPage() {
        return this.ytSearchPageResponse && this.ytSearchPageResponse.nextPageToken;
    }
    hasPrevVideoSearchPage() {
        return this.ytSearchPageResponse && this.ytSearchPageResponse.prevPageToken;
    }

    nextVideoSearchPage() {
        if (this.hasNextVideoSearchPage()) {
            this.doVideoSearch(this.ytSearchPageResponse.nextPageToken);
        }
    }
    prevVideoSearchPage() {
        if (this.hasPrevVideoSearchPage()) {
            this.doVideoSearch(this.ytSearchPageResponse.prevPageToken);
        }
    }

    getTotalYTVideoResultsCount() {
        return get(this.ytSearchPageResponse, 'pageInfo.totalResults', 0);
    }

    handleVideoSearch() {
        this.doVideoSearch(undefined);
    }

    async doVideoSearch(pageToken: string) {
        this.loadingYoutubeSearch = true;
        this.youtubeSearchResults = [];
        // console.log('test');
        // console.log(this.selectedVideoSourceResult);
        const currentVideos = this.selectedVideoSourceResult
            .filter(item => item.mapping_type === 'VIDEO')
            .map(item => item.mapping_value)
            .concat(
                this.selectedRequestResult
                    .filter(item => item.mapping_type === 'VIDEO')
                    .map(item => item.mapping_value)
            );
        // console.log(currentVideos);
        this.ytSearchPageResponse = null;
        try {
            const res = await this.datahealthService.getYoutubeVideos(this.youtubeSearchQuery, pageToken);
            this.ytSearchPageResponse = res;
            this.youtubeSearchResults = res.items.map(item => {
                return {
                    id: item.id.videoId,
                    title: item.snippet.title,
                    description: item.snippet.description,
                    publishedAt: item.snippet.publishedAt,
                    publishedAtString: new Date(item.snippet.publishedAt).toLocaleDateString('nz'),
                    thumbnailLink: item.snippet.thumbnails.default.url,
                    exists: currentVideos.includes(item.id.videoId),
                    collasped: false,
                    loading: false
                };
            });
            this.loadingYoutubeSearch = false;
        } catch (err) {
            this.loadingYoutubeSearch = false;
            console.error('Failed to query youtube for videos: ' + err);
            this.toasterService.pop('error', 'Failed to query youtube for videos!');
        }
    }

    handleCollapse(item) {
        item.collapsed = !item.collapsed;
    }

    handleCreateVideo(event, youtubeResult) {
        this.selectedMapping.mapping_value = youtubeResult.id;
        this.selectedMapping.published_at_time = youtubeResult.publishedAt;
        youtubeResult.loading = true;
        this.onClickCreate(event);
    }

    handleYoutubeGoBack() {
        if (this.youtubeAdded) {
            this.clickCatalog(this.selectedTitle);
            this.getMappingRequestTitles();
            this.youtubeAdded = false;
        } else {
            this.goBack();
        }
    }

    handleMsDate(ms: number) {
        if (ms !== undefined) {
            const date = new Date(ms);
            return date.toLocaleDateString() + ' ' + date.toLocaleTimeString();
        } else {
            return '';
        }
    }

    async enableEditMode(flag) {
        this.editMode = true;
        this.imdbChanged = [];
    }

    getYoutubeSearchTerms(selectedSourceResult: any[]) {

    }

    removeFromList(value) {
        const updatedList = this.selectedSearchTermResult && this.selectedSearchTermResult.slice().filter(item => item !== value);
        this.selectedSearchTermResult = updatedList;
    }

    private getSearchtermListYoutube(sourceResult) {

        const finalResult = sourceResult.filter(item => item.mapping_type === 'SEARCH_TERM').map(x => x.mapping_value.replace(/\"/g, ''));
        if ( finalResult.length > 0 ) {
            const sanitizedResult = finalResult[0].replace(/\"/g, '');
            const sanitisedArray = sanitizedResult.split('|');
            this.originalSearchTermResult = 1;
            return  sanitisedArray;
        }
        return [];
    }

    reorderedList($event: any) {
       this.selectedSearchTermResult = $event;
    }

    testSearchTerms($event: MouseEvent) {

        const searchTerms =  this.selectedSearchTermResult.map(x => '\"' + x + '\"').join('|');
        const newWindow = window.open('https://www.youtube.com/results?search_query=' + searchTerms);

    }
}




// WEBPACK FOOTER //
// ./src/app/catalogue/datahealth/datahealth.component.ts